<template>
  <!-- 准货主 -->
  <el-form-item label="准货主">
    <el-select
      v-model="entrust_pid"
      :disabled="modify"
      filterable
      remote
      placeholder="请选择准货主"
      @focus="remoteMethod_name"
      @change="unitName"
    >
      <el-option
        v-for="(item, index) in enterpriseList"
        :key="index"
        :label="item.member_name"
        :value="item.user_id"
      ></el-option>
    </el-select>
    <i class="iconfont icon-icon12 unit"></i>
  </el-form-item>
</template>

<script>
import { isSuccess } from "@/assets/js/utils";
export default {
  data() {
    return {
      enterpriseList: [],
      entrust_pid: this.entrustPid, //合同pid
      entrust_name: this.entrustName, //合同名称
      modify: this.entrustModify,
      entrust_user_ids: this.userIds,
    };
  },
  //   props: ['infoPid', 'infoCode', 'infoName', 'ifModify'],
  props: {
    entrustPid: {
      required: false,
    },
    entrustName: {
      required: false,
    },
    entrustModify: {
      required: false,
    },
    userIds: {
      required: false,
    },
  },
  created() {},
  watch: {
    entrustPid: function (newVal, oldVal) {
      this.entrust_pid = newVal;
    },
    entrustName: function (newVal, oldVal) {
      this.entrust_name = newVal;
    },
    entrustModify: function (newVal, oldVal) {
      this.modify = newVal;
    },
    userIds: function (newVal, oldVal) {
      this.entrust_user_ids = newVal;
    },
  },
  methods: {
    remoteMethod_name() {
      let json = [];
      if (this.entrust_user_ids) {
        this.entrust_user_ids.forEach((item) => {
          json.push(item.user_id);
        });
      }
      api("entrust.cargo", { user_ids: json }).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          this.enterpriseList = data;
        }
      });
    },
    unitName(val) {
      this.entrust_name = this.enterpriseList.find((item) => {
        return item.user_id === val;
      }).member_name;
      this.$emit("getEntrust", val, this.entrust_name);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/unitcode/enterprise-code.vue